var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{attrs:{"color":"red","rounded":"","height":"25"},model:{value:(_vm.power),callback:function ($$v) {_vm.power=$$v},expression:"power"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }